(() => {
  document.querySelectorAll('.newsletter__subheading').forEach((node) => {
    const stockCopy = 'Be the first to know about new collections and exclusive offers.';
    if (node.textContent.trim() === stockCopy) {
      node.innerHTML = '<p>New drops, restocks, and questionable decisions. Straight to your inbox.</p>';
    }
  });

  const dialog = document.querySelector('[data-oc-subscribe-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const form = dialog.querySelector('form');
  const email = dialog.querySelector('#OCSubscribeEmail');
  const emailStage = dialog.querySelector('[data-oc-subscribe-stage="email"]');
  const muppetStage = dialog.querySelector('[data-oc-subscribe-stage="muppets"]');
  const question = dialog.querySelector('#OCSubscribeQuestion');
  const choices = Array.from(dialog.querySelectorAll('[data-oc-muppet-choice]'));
  const choiceError = dialog.querySelector('[data-oc-choice-error]');
  const success = dialog.querySelector('[data-oc-subscribe-success]');
  const formError = dialog.querySelector('[data-oc-subscribe-form-error]');
  const formResult = dialog.querySelector('[data-oc-form-result]');
  const seenKey = 'oc-subscribe-popup-seen-v1';
  const pendingKey = 'oc-subscribe-popup-pending-v1';
  const alreadySubscribed = dialog.dataset.ocAlreadySubscribed === 'true';
  const postedSuccessfully = formResult?.dataset.success === 'true';
  const postedWithError = formResult?.dataset.error === 'true';
  let seenInMemory = false;
  let submitting = false;
  let lockedScrollY = 0;
  let bodyStyleSnapshot = null;

  const readSession = (key) => {
    try { return sessionStorage.getItem(key) === '1'; }
    catch (_) { return false; }
  };
  const writeSession = (key) => {
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* Continue without storage. */ }
  };
  const clearSession = (key) => {
    try { sessionStorage.removeItem(key); } catch (_) { /* Continue without storage. */ }
  };
  const hasSeen = () => seenInMemory || readSession(seenKey);
  const rememberSeen = () => { seenInMemory = true; writeSession(seenKey); };

  const lockPageScroll = () => {
    if (document.documentElement.classList.contains('oc-subscribe-page-locked')) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    bodyStyleSnapshot = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    document.documentElement.classList.add('oc-subscribe-page-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const unlockPageScroll = () => {
    if (!document.documentElement.classList.contains('oc-subscribe-page-locked')) return;

    document.documentElement.classList.remove('oc-subscribe-page-locked');

    if (bodyStyleSnapshot) {
      document.body.style.position = bodyStyleSnapshot.position;
      document.body.style.top = bodyStyleSnapshot.top;
      document.body.style.left = bodyStyleSnapshot.left;
      document.body.style.right = bodyStyleSnapshot.right;
      document.body.style.width = bodyStyleSnapshot.width;
      document.body.style.overflow = bodyStyleSnapshot.overflow;
    }

    window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
    bodyStyleSnapshot = null;
  };

  const showStage = (stage) => {
    dialog.dataset.ocStage = stage;
    if (stage !== 'email') closeKeyboardMode();
    emailStage.hidden = stage !== 'email';
    muppetStage.hidden = stage !== 'muppets';
    success.hidden = stage !== 'success';
    choiceError.hidden = true;
    if (formError && stage !== 'email') formError.hidden = true;

    if (dialog.open) {
      requestAnimationFrame(() => {
        if (!dialog.open) return;
        if (stage === 'email') email.focus({ preventScroll: true });
        else if (stage === 'muppets') question.focus({ preventScroll: true });
        else dialog.querySelector('[data-oc-subscribe-close]').focus({ preventScroll: true });
      });
    }
  };

  let viewportFrame = 0;
  let emailFocusTimer = 0;
  let baselineViewportHeight = window.visualViewport?.height || window.innerHeight;
  let measuredKeyboard = false;
  const onMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const closeKeyboardMode = () => {
    cancelAnimationFrame(viewportFrame);
    dialog.dataset.ocKeyboardOpen = 'false';
    measuredKeyboard = false;
    dialog.style.removeProperty('--oc-subscribe-keyboard-shift');
  };
  const syncPopupViewport = () => {
    if (!dialog.open || !onMobile()) return;

    const viewport = window.visualViewport;
    const visibleHeight = viewport?.height || window.innerHeight;
    const visibleTop = measuredKeyboard ? (viewport?.offsetTop || 0) : 0;
    dialog.style.setProperty('--oc-subscribe-viewport-top', `${visibleTop}px`);
    if (dialog.dataset.ocKeyboardOpen !== 'true') return;

    cancelAnimationFrame(viewportFrame);
    viewportFrame = requestAnimationFrame(() => {
      if (!dialog.open || dialog.dataset.ocStage !== 'email' || document.activeElement !== email) return;
      dialog.style.setProperty('--oc-subscribe-keyboard-shift', '0px');
      const keyboardTop = measuredKeyboard ? visibleTop + visibleHeight : baselineViewportHeight * .52;
      const nextButton = dialog.querySelector('[data-oc-subscribe-next]');
      const shift = Math.ceil(Math.max(0, nextButton.getBoundingClientRect().bottom - keyboardTop + 12));
      dialog.style.setProperty('--oc-subscribe-keyboard-shift', `${shift}px`);
    });
  };
  const activateKeyboardMode = () => {
    if (!dialog.open || !onMobile() || dialog.dataset.ocStage !== 'email' || document.activeElement !== email) return;
    dialog.dataset.ocKeyboardOpen = 'true';
    syncPopupViewport();
  };
  const onViewportChange = () => {
    if (!dialog.open || !onMobile()) return;
    const height = window.visualViewport?.height || window.innerHeight;
    if (dialog.dataset.ocStage === 'email' && document.activeElement === email) {
      const reduction = baselineViewportHeight - height;
      if (reduction > 100) {
        measuredKeyboard = true;
        activateKeyboardMode();
      } else if (measuredKeyboard && reduction < 60) {
        closeKeyboardMode();
      }
    }
    syncPopupViewport();
  };
  email.addEventListener('focus', () => {
    window.clearTimeout(emailFocusTimer);
    emailFocusTimer = window.setTimeout(activateKeyboardMode, 280);
  });
  email.addEventListener('blur', () => {
    window.clearTimeout(emailFocusTimer);
    closeKeyboardMode();
  });
  window.visualViewport?.addEventListener('resize', onViewportChange);
  window.visualViewport?.addEventListener('scroll', onViewportChange);
  window.addEventListener('resize', onViewportChange);

  const openPopup = (stage) => {
    if (dialog.open) {
      showStage(stage);
      return;
    }
    if (document.querySelector('dialog[open]')) {
      window.setTimeout(() => openPopup(stage), 1500);
      return;
    }
    baselineViewportHeight = window.visualViewport?.height || window.innerHeight;
    showStage(stage);
    lockPageScroll();
    dialog.showModal();
    syncPopupViewport();
    rememberSeen();
    requestAnimationFrame(() => {
      if (stage === 'muppets') question.focus({ preventScroll: true });
      else if (stage === 'success') dialog.querySelector('[data-oc-subscribe-close]').focus({ preventScroll: true });
      else email.focus({ preventScroll: true });
    });
  };

  const advance = () => {
    if (!email.reportValidity()) return;
    showStage('muppets');
  };

  dialog.querySelector('[data-oc-subscribe-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    closeKeyboardMode();
    choices.forEach((choice) => { choice.checked = false; });
    unlockPageScroll();
  });
  dialog.querySelector('[data-oc-subscribe-next]').addEventListener('click', advance);
  dialog.querySelector('[data-oc-subscribe-back]').addEventListener('click', () => showStage('email'));

  choices.forEach((choice) => choice.addEventListener('change', () => {
    if (choices.some((item) => item.checked)) choiceError.hidden = true;
  }));

  form.addEventListener('submit', (event) => {
    if (!emailStage.hidden) {
      event.preventDefault();
      advance();
      return;
    }

    if (muppetStage.hidden || !choices.some((choice) => choice.checked)) {
      event.preventDefault();
      choiceError.hidden = false;
      choices[0].focus({ preventScroll: true });
      return;
    }

    if (submitting) {
      event.preventDefault();
      return;
    }

    submitting = true;
    writeSession(pendingKey);
  });

  document.addEventListener('submit', (event) => {
    const sourceForm = event.target;
    if (!sourceForm.matches?.('form.newsletter-form') || sourceForm.closest('[data-oc-subscribe-popup]')) return;
    const sourceEmail = sourceForm.querySelector('input[name="contact[email]"]');
    if (!sourceEmail) return;

    event.preventDefault();
    if (!sourceEmail.reportValidity()) return;
    email.value = sourceEmail.value.trim();
    openPopup('muppets');
  }, true);

  if (readSession(pendingKey)) {
    clearSession(pendingKey);

    if (postedSuccessfully) {
      openPopup('success');
      return;
    }

    if (postedWithError) {
      openPopup('email');
      return;
    }
  }

  if (postedSuccessfully) {
    openPopup('success');
    return;
  }

  if (!alreadySubscribed && !hasSeen()) {
    window.setTimeout(() => {
      if (!hasSeen()) openPopup('email');
    }, 6500);
  }
})();
